import { DEFAULT_SCHEDULE_RULES } from "./scheduler.js";
export const SCHEDULE_PRESETS = [
    {
        key: "business_hours",
        labelKey: "schedule.presets.businessHours.label",
        descriptionKey: "schedule.presets.businessHours.description",
        rules: {
            ...DEFAULT_SCHEDULE_RULES,
            activeDays: [1, 2, 3, 4, 5],
            timeWindows: [
                { start: "09:00", end: "11:30" },
                { start: "13:30", end: "16:30" },
            ],
            postsPerWeekMin: 3,
            postsPerWeekMax: 5,
            quietHours: { start: "18:00", end: "08:00" },
        },
    },
    {
        key: "evenings_weekends",
        labelKey: "schedule.presets.eveningsWeekends.label",
        descriptionKey: "schedule.presets.eveningsWeekends.description",
        rules: {
            ...DEFAULT_SCHEDULE_RULES,
            activeDays: [0, 4, 5, 6],
            timeWindows: [
                { start: "17:30", end: "20:00" },
                { start: "20:00", end: "22:00" },
            ],
            postsPerWeekMin: 2,
            postsPerWeekMax: 4,
            quietHours: { start: "23:00", end: "09:00" },
        },
    },
    {
        key: "natural_mix",
        labelKey: "schedule.presets.naturalMix.label",
        descriptionKey: "schedule.presets.naturalMix.description",
        rules: {
            ...DEFAULT_SCHEDULE_RULES,
            // The "natural mix" is the everyday shape, so it posts every day.
            activeDays: [0, 1, 2, 3, 4, 5, 6],
            timeWindows: [
                { start: "08:00", end: "10:30" },
                { start: "12:30", end: "14:00" },
                { start: "18:00", end: "21:00" },
            ],
            postsPerWeekMin: 4,
            postsPerWeekMax: 6,
            jitterMinutes: 25,
            quietHours: { start: "22:00", end: "06:00" },
        },
    },
];
export function presetFor(key) {
    const preset = SCHEDULE_PRESETS.find((p) => p.key === key);
    if (!preset)
        throw new Error(`Unknown schedule preset: ${key}`);
    return preset;
}
//# sourceMappingURL=presets.js.map